import { useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { actionConsts, actionConts2, reducer } from "../newComponents/StateManager";
import { HbrCancel } from "../newComponents/Mycustomsvgicons";
import { uploadBytesResumable, ref as storageRef, getDownloadURL} from "firebase/storage";
import { realTimeDB, storage } from "../firebase";
import AxiosApi from "./AxiosApi";
import { ConstVariables } from "./ConstantVariables";
import { AuthContext } from "../AuthContext";
import { deleteStorageFile } from "../Utils/ManageMediaFiles";
import { MessageGenreListDefault, Preachers } from "../Utils/ArraysofData";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { getMessageGenres, initDB, storeMessageGenreToLocalDB } from "../ConfigureIndexDB";
import { off, onValue, ref } from "firebase/database";
import OptionalDialog from "./OptionalDialog";

const UploadMessages = ({handleCancel}) => {
    const [messageTitle, setMessageTitle] = useState("");
    const [preacher, setPreacher] = useState("");
    const [selectedAudioFile, setSelectedAudioFile] = useState(null);
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [videoLink, setVideoLink] = useState("");
    const [messageGenre, setMessageGenre] = useState("");
    const [isPlaying, setIsPlaying] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [newGenre, setNewGenre] = useState("");
    const [messageGenresFromLocalDB, setMessageGenreListFromDB] = useState([]);
    const [uploadedMessages, setUploadedMessages] = useState([]);
    const [state,dispatch]=useReducer(reducer,{videoUrl:"",capturedThumbnail:"", videoDescription:"", audioUrl:"",shortsDescCount: 0,uploadProgress: "",progressIndicator: false, showAlert: false, 
    alertMessage: "",showOptionalDialog: false});
    const {user_email}= useContext(AuthContext);
    const playerRef = useRef(null);
    const audioPlayerRef = useRef(null);
    const selectVideoRef = useRef(null);
    const selectAudioRef = useRef(null);
    const uploadMessageRef = useRef(null);
    const canvasRef = useRef(null);
    const maxwordLength = 400;


    useEffect(() => {
        async function fethcMessageGenres() {
            await initDB();
            const messageGenreFromDB = await getMessageGenres();
            if (messageGenreFromDB.length > 0) {
                setMessageGenreListFromDB([...messageGenreFromDB,...MessageGenreListDefault]);
            }else{
                setMessageGenreListFromDB(MessageGenreListDefault)
            }
        }
        fethcMessageGenres();
    }, []);

    useEffect(()=>{
        let words = state.videoDescription.split(' ');
            if(words.length >= maxwordLength){
                words = words.slice(0,maxwordLength);
                dispatch({type: actionConts2.VIDEO_DESCRIPTION, payload: words.join(' ')});
            }
            dispatch({type: actionConsts.SHORTS_DESC_COUNT, payload: words.length});
    },[state.videoDescription]);

    useEffect(() => {
        const messageTitleRef = ref(realTimeDB,`hrmw_messages_titles`);
        const listener = onValue(messageTitleRef, (snapshot)=>{
            if (snapshot.exists()) {
                const data = snapshot.val();
                const titleArray = Object.values(data);
             setUploadedMessages(titleArray);   
            }
        });
        return()=>off(messageTitleRef,'value', listener);
    },[]);

    const memoizedMessagesTitles = useMemo(()=>uploadedMessages,[uploadedMessages]);
    
    const handleDisableDescriptionTextbox=(e)=>{
        if(state.shortsDescCount >= maxwordLength && e.key !== 'Backspace' && e.key !== 'Delete'){
            e.preventDefault();
        }
    };

    const handleSelectVideo =()=>{
        selectVideoRef.current.click();
    };
    const handleVideoSelectionChange = (e) => {
        const videoFile = e.target.files[0];
        const videoUrl = URL.createObjectURL(videoFile);
        dispatch({type: actionConts2.VIDEO_URL, payload: videoUrl});
    };
    const handleVideoPlayback = () => {
        if (playerRef.current) {
            if (isPlaying) {
                playerRef.current.pause();
                setIsPlaying(false);
            } else {
                playerRef.current.play();
                setIsPlaying(true);
            }   
        }
    };
     const handleCaptureShortsThumb=useCallback(()=>{
            if(state.videoUrl && state.videoUrl !== ""){
                try {
                      const canvas = canvasRef.current;
                const video = playerRef.current;
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    
                dispatch({type: actionConts2.VIDEO_THUMBNAIL, payload: canvas.toDataURL("image/jpeg")});
                canvas.toBlob((blob)=>{setThumbnailFile(blob)},'image/jpeg');
                } catch (error) {
                    console.error("Error capturing thumbnail:", error);
                }
            }
    
    },[state.videoUrl]);

    useEffect(()=>{
        let timeid = setTimeout(() => {
            handleCaptureShortsThumb();
        }, 2000);
        return () => clearTimeout(timeid);
    },[handleCaptureShortsThumb]);

     const handleAudioSelectionChange = (e) => {
        const audioFile = e.target.files[0];
        setMessageTitle(audioFile.name.replace(/\.[^/.]+$/, ""));
        const audioUrl = URL.createObjectURL(audioFile);
        dispatch({type: actionConts2.AUDIO_URL, payload: audioUrl});
        setSelectedAudioFile(audioFile);
    };

    const cancelUpload = () => {
        if (uploadMessageRef.current) {
            try {
            uploadMessageRef.current.cancel();
            uploadMessageRef.current = null;
            setUploading(false);
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Upload cancelled."});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            } catch{
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "failed to cancel upload."});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            }
        }
    };

    function normalize(str) {
    return (str || '').replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase();
    }

    const uploadMessage= async()=>{
        if (!selectedAudioFile || !thumbnailFile) {
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Please select both audio and thumbnail files."});
            return dispatch({type: actionConsts.SHOWALERT, payload: true});
        }
        setUploading(true);
         dispatch({type: actionConsts.UPLOAD_PROGRESS, payload: `Running checks ...`});

         const matchedTitles = [];
        for(const key in memoizedMessagesTitles){
            const memoTitile = memoizedMessagesTitles[key].title;
            const normalizedMemoTitle = normalize(memoTitile);
            const normalizedInputTitle = normalize(messageTitle).split(' ');
            let match = 0;
           
            for(const word of normalizedInputTitle){
                if(normalizedMemoTitle.includes(word)){
                    match++;
                }
            }
            const lengthOfTitle = normalizedInputTitle.length;
            const matchScore = (match / lengthOfTitle) * 100;
            if (matchScore > 35) {
                matchedTitles.push({title: memoTitile, matchScore: matchScore});
            }
        }
        if (matchedTitles.length > 0) {
            const sortedMatchedTitles = matchedTitles.sort((a, b) => b.matchScore - a.matchScore).slice(0, 30).map(item => item.title);
             setUploading(false);
             dispatch({type: actionConsts.ALERT_MESSAGE, payload: `Check for Similar messages. If no similar message exist click on Proceed else click on Cancel to select a new message:\n\nSimilar Messages: \n\n ${sortedMatchedTitles.join("\n\n")}`});
            dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: true});
        }else{
              dispatch({type: actionConsts.ALERT_MESSAGE, payload: "No similar messages found. Click proceed to upload."});
             dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: true});
              setUploading(false);
        }
    };

    const storeNewGenre = async()=>{
        if (newGenre.trim() !== "") {
            try {
            const newGnereId = new Date().getTime();
            await initDB();
            await storeMessageGenreToLocalDB({id: newGnereId, genre: newGenre});
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: `${newGenre} is successfully to the genre list. Please select it from the dropdown.`});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            setMessageGenreListFromDB(prevGenres => [...prevGenres, {id: newGnereId, genre: newGenre}]);
            setNewGenre("");
            } catch (error) {
                console.error("Error storing new message genre:", error);
            }
        }else{
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Please enter a valid genre."});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
        }
    };
    const memoizedMessageGenreList = useMemo(() => messageGenresFromLocalDB,[messageGenresFromLocalDB]);

    const handleCloseAlert=(data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    };
    const positiveAction=()=>{
        dispatch({type: actionConsts.SHOWALERT, payload: false});
         dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: false});
        setUploading(true);
        uploadMessageRef.current = uploadBytesResumable(storageRef(storage, `messages/${messageTitle}`), selectedAudioFile);
        uploadMessageRef.current.on('state_changed',
            (snapshot)=>{
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes).toFixed(2) * 100;
                dispatch({type: actionConsts.UPLOAD_PROGRESS, payload: `Uploading audio...${progress}%`});
            },
            (error) => {
                setUploading(false);
                console.error("Error uploading message:");
            },
            ()=> {
                getDownloadURL(uploadMessageRef.current.snapshot.ref).then((downloadURL) => {
                    uploadMessageRef.current = null;
                        if (!thumbnailFile) {
                            setUploading(false);
                        return console.error("No thumbnail file selected for upload.");
                        }
                       const uploadThumbnailBytesData = uploadBytesResumable(storageRef(storage, `message_thumbnail/${messageTitle}`), thumbnailFile);
                       uploadThumbnailBytesData.on('state_changed',
                        (snapshot) => {
                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes).toFixed(2) * 100;
                             dispatch({type: actionConsts.UPLOAD_PROGRESS, payload: `Uploading thumbnail...${progress}%`});
                        },
                        (error) => {
                            setUploading(false);
                            console.error("Error uploading thumbnail:", error);
                        },
                        () => {
                            getDownloadURL(uploadThumbnailBytesData.snapshot.ref).then(async (thumbnailDownloadURL) => {
                                const messageData = {
                                    title: messageTitle,
                                    preacher: preacher,
                                    description: state.videoDescription,
                                    videoUrl: videoLink,
                                    url: downloadURL,
                                    thumbnail: thumbnailDownloadURL,
                                    genre: messageGenre,
                                    user_email,
                                    api_key: process.env.REACT_APP_CONNECTERE_KEY,
                                };
                                try {
                                    const res = await AxiosApi.post("/uploadMessage", JSON.stringify(messageData),
                                        {
                                            headers: { 'Content-Type': 'application/json' },
                                            withCredentials: false
                                        }
                                    );
                                    dispatch({type: actionConsts.ALERT_MESSAGE, payload: res.data.success});
                                    dispatch({type: actionConsts.SHOWALERT, payload: true});
                                    setUploading(false);
                                } catch (error) {
                                    if (!error?.response) {
                                        dispatch({type: actionConsts.ALERT_MESSAGE, payload: ConstVariables.NO_SERVER_RESPONSE});
                                        dispatch({type: actionConsts.SHOWALERT, payload: true});
                                    }else{
                                        dispatch({type: actionConsts.ALERT_MESSAGE, payload: error?.response.data.message});
                                        dispatch({type: actionConsts.SHOWALERT, payload: true});
                                    }
                                    setUploading(false);
                                    deleteStorageFile(`messages/${messageTitle}`);
                                    deleteStorageFile(`message_thumbnail/${messageTitle}`);
                                }
                            }).catch((err) => {
                                setUploading(false);
                                dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Error getting thumbnail download URL. contact support team."});
                                dispatch({type: actionConsts.SHOWALERT, payload: true});
                                console.error("Error getting thumbnail download URL:", err);
                                deleteStorageFile(`messages/${messageTitle}`);
                                deleteStorageFile(`message_thumbnail/${messageTitle}`);
                            });
                        }
                       )
                }).catch((err)=>{
                    setUploading(false);
                    dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Error getting message download URL. contact support team."});
                    dispatch({type: actionConsts.SHOWALERT, payload: true});
                    deleteStorageFile(`messages/${messageTitle}`);
                });
            }
        )
    };

    return ( 
    <div className="upload-messages">
        <div className="upload-messages-overlay flex-spacearound" style={{position:"relative",width:"100%", height:"100%", borderRadius:"10px"}}>
            <div className="flex-spacebetween" style={{position:"absolute", top:"0", left:"0", width:"100%", height:"50px"}}>
                <h3 style={{color:"white", textAlign:"center", paddingTop:"10px"}}>Upload Messages Studio</h3>
                <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleCancel()}/>
            </div>

            <div className="message-video flex-column1" style={{width:"45%", height:"100%", gap:"10px", marginTop:"150px"}}>
                <input type="file" accept="video/mp4" id="select-message-video" onChange={handleVideoSelectionChange} ref={selectVideoRef} style={{display:"none"}}/>
                <label htmlFor="select-message-video">
                    <button className="buttonstyle" style={{backgroundColor:"white"}} onClick={()=>handleSelectVideo()}>{`${state.videoUrl !=="" ? 'Change video':'Select video'}`}</button>
                </label>
                
                 {state.videoUrl !== "" ? 
                    <video
                    onClick={handleVideoPlayback}
                    src={state.videoUrl}
                    ref={playerRef}
                    controls
                    loop
                    width="100%"
                    height="45%"/>
                    :
                    <div className="hrmwmessage-video-placeholder" style={{width:"100%", height:"45%", backgroundColor:"black", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <h3 style={{color:"white"}}>Message Video</h3>
                    </div>
                }
                <label style={{color:"white", fontWeight:"bold"}}>Video Thumbnail</label>
                {state.capturedThumbnail && state.capturedThumbnail !== "" ? 
                    <img className="hrmwmessage-thumbnail" src={state.capturedThumbnail} alt="" style={{width:"150px", height:"150px", objectFit:"cover"}}/>
                    :
                    <div className="hrmwmessage-thumbnail-placeholder" style={{width:"150px",height:"150px",border:"2px solid white", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <h3 style={{color:"white"}}>Video Thumbnail</h3>
                    </div>
                }

                <div className="flex-spacearound" style={{width:"100%"}}>
                    {state.capturedThumbnail !== "" && 
                    <button className="buttonstyle" style={{backgroundColor:"white"}} onClick={handleCaptureShortsThumb}>Recapture Thumbnail</button>
                    }
                 
                    {state.capturedThumbnail === "" &&
                    <button className="buttonstyle" style={{backgroundColor:"white"}} onClick={handleCaptureShortsThumb}>Select from Device</button>
                    }
                </div>

                 <canvas ref={canvasRef} style={{display:"none"}} />
            </div>
              
            <div className="message-details flex-column1" style={{width:"50%", height:"100%", marginTop:"150px"}}>
                <label>Message Title:</label>
                <input type="text" list="messages_list" required value={messageTitle} onChange={e => setMessageTitle(e.target.value)}/>
                <datalist id="messages_list">
                    {memoizedMessagesTitles && memoizedMessagesTitles.map((data, index)=>(
                        <option key={index} value={data.title}></option>
                    ))}
                </datalist>
                <br/>
                
                <label>Preacher</label>
                <input type="text" list="preacher-list" required value={preacher} onChange={e => setPreacher(e.target.value)}/>
                <datalist id="preacher-list">
                    {Preachers.map((data,index)=>(
                        <option key={index} value={data}></option>
                    ))}
                </datalist>
                <br/>
                
                <label>Description</label>
                <textarea
                required
                placeholder="Message description" 
                rows="6"
                onKeyDown={handleDisableDescriptionTextbox}
                value={state.videoDescription}
                onChange={e => dispatch({type:actionConts2.VIDEO_DESCRIPTION, payload: e.target.value})}
                style={{width:"100%", padding:"10px", outline:"none", border:"none", backgroundColor:"var(--warmer_dark_shade)", color:"var(--white)", fontWeight:"bold"}}
                />
                <br/>

                <label>Audio Format:</label>
                <input type="file" accept="audio/mp3" id="select-message-audio" onChange={handleAudioSelectionChange} ref={selectAudioRef} style={{display:"none"}}/>
                <label htmlFor="select-message-audio">
                    <button className="buttonstyle" style={{backgroundColor:"white", width:"300PX"}} onClick={()=>selectAudioRef.current.click()}>{`${state.audioUrl !=="" ? 'Change audio':'Select audio'}`}</button>
                </label>
                {state.audioUrl !== "" && 
                    <audio controls ref={audioPlayerRef} src={state.audioUrl} style={{width:"100%", height:"50px"}}/>
                }
                <br/><br/>

                <label>{`Video (youtube link):`}</label>
                <input type="url" required value={videoLink} onChange={e => setVideoLink(e.target.value)}/>
                <br/>

                <label>Message Genre</label>
                <select required value={messageGenre} onChange={e => setMessageGenre(e.target.value)}>
                    {memoizedMessageGenreList && memoizedMessageGenreList.map((data, index)=>(
                        <option key={data?.id ? data.id : index } value={data.genre}>{data.genre}</option>
                    ))}
                </select>
                <br/>

                <div className="flex-spacearound" style={{width:"100%"}}>
                    <button className="buttonstyle" style={{backgroundColor:"green", color:"white"}} onClick={()=>uploadMessage()}>
                        Publish
                    </button>
                </div>
                <br/>

                <label>Add the appropriate message genre if not included in the list above</label>
                <input type="text" value={newGenre} onChange={e => setNewGenre(e.target.value)} style={{width:"100%", padding:"10px", outline:"none", border:"none", backgroundColor:"var(--warmer_dark_shade)", color:"var(--white)", fontWeight:"bold"}}/>
                <button className="buttonstyle" style={{backgroundColor:"white"}} onClick={()=>storeNewGenre()}>Add New Genre</button>
                <br/>
            </div>

            {uploading && 
                <div className="uploadshortsprogressinfo flex-column2">
                        <p style={{color: "white",fontWeight:"bold"}}>{state.uploadProgress}</p>
                    <div className="uploadshortspreloader">
                        <p style={{color: "white",fontWeight:"bold"}}>Uploading...</p>
                    </div>
                    <button className="buttonstyle" style={{backgroundColor:"red", color:"white"}} onClick={()=>cancelUpload()}>
                        Cancel
                    </button>
                </div>
            }
            {state.showAlert &&
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert} />
            }

            {state.showOptionalDialog && 
            <OptionalDialog
                message={state.alertMessage}
                positiveBtn={"Proceed"}
                negBtn={"Cancel"}
                positiveAction={positiveAction}
                negativeAction={()=>dispatch({type: actionConts2.OPTIONAL_DIALOG, payload: false})}
            />
            }
        </div>
    </div>
    );
}
export default UploadMessages;